import useCustomerWebSocket from './useCustomerWebSocket';
import useLiveWebSocket from './useLiveWebSocket';

// Simplified main WebSocket hook that orchestrates both connections
export default function useWebSocket() {
  const customerWS = useCustomerWebSocket();
  const liveWS = useLiveWebSocket();

  // Calculate signal strength based on connected WebSockets
  // 0% = no connections, 50% = 1 connection, 100% = 2 connections
  const connectedCount = [customerWS.status, liveWS.status].filter(status => status === 'connected').length;
  const signalStrength = connectedCount === 0 ? 0 : connectedCount === 1 ? 50 : 100;

  // Force reconnection for both WebSockets
  const forceReconnectAll = () => {
    customerWS.forceReconnect();
    liveWS.forceReconnect();
  };

  return {
    customerStatus: customerWS.status,
    liveStatus: liveWS.status,
    signalStrength,
    forceReconnectAll,
    webSocketStatus: {
      customerStatus: customerWS.status,
      liveStatus: liveWS.status,
      signalStrength,
    },
  };
}
